module.exports = {"title":"Ibon Cano","subtitle":"DevOps Engineer","image":"home-background.jpg"}